'use client'
import { useGetFleetTypes } from './useGetFleetTypes';

export const useGetFleetType = (fleetType?: string | null) => {
    const { data: fleetTypes } = useGetFleetTypes();
    return fleetType ? fleetTypes?.find((type) => type.slug === fleetType) : undefined;
};
